"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractAddress = void 0;
const ChainId = {
  Ethereum: 1,
  Sepolia: 11155111,
  Polygon: 137,
  PolygonAmoy: 80002,
  XDC: 50,
  XDCApothem: 51,
  Stability: 101010,
  StabilityTestnet: 20180427,
  Astron: 1338,
  AstronTestnet: 21002
};
const contractAddress = exports.contractAddress = {
  TitleEscrowFactory: {
    [ChainId.Ethereum]: "0x65FC1DbE2EC6BD37Ab01C3Ac3cf235e6Fe793745",
    [ChainId.Sepolia]: "0xfcafea839e576967b96ad1FBFB52b5CA26cd1D25",
    [ChainId.Polygon]: "0xF94f95014304dC45B097439765A4D321bbE165c7",
    [ChainId.PolygonAmoy]: "0x8bbCc8F707DE9ca637f83182215E3BfC53f3e9e1",
    [ChainId.XDC]: "0x9310396503A188E91dfc98fFE90459c25765E639",
    [ChainId.XDCApothem]: "0xca70f36aeeda435c1048fd372bf286a41ac538be",
    [ChainId.Stability]: "0x96cc41e7007Dee20eB409586E2e8206d5053219B",
    [ChainId.StabilityTestnet]: "0xAac003619FA8C7008C73704a550aA2bF20951dbb",
    [ChainId.Astron]: "0xa1fCAE62b69D85BfBb5B447f038123A1e4d8f6eC",
    [ChainId.AstronTestnet]: "0x812A0E71c61A42C8d3d449BdfF51834f85686C73"
  },
  Deployer: {
    [ChainId.Ethereum]: "0xEc6fD701743cEdf504873F5E5E807586f437A500",
    [ChainId.Sepolia]: "0x64bc665056DC8bE4092e569ED13a7F273Be28cD2",
    [ChainId.Polygon]: "0xddDabC072c7Ea9c40e3751ff834519be15BCFA54",
    [ChainId.StabilityTestnet]: "0x9AA24846D19098b6abE79C488DD783B2FbAF3eEE",
    [ChainId.Stability]: "0xCa70F36aEEDA435c1048FD372Bf286a41ac538Be",
    [ChainId.XDC]: "0x9EFE3127e4F3f4e4CF83132F05BE11a097e0f9Ca",
    [ChainId.XDCApothem]: "0x20284AFe0B36545611dCF90Bb8128FC52e24247F",
    [ChainId.PolygonAmoy]: "0xfcafea839e576967b96ad1FBFB52b5CA26cd1D25",
    [ChainId.Astron]: "0x79ED245fFecdAF8C87BFE35ccF6A7b9FE9024240",
    [ChainId.AstronTestnet]: "0x1043B46Ad9072fB784492d94F8d25eF679B7AAf8"
  },
  TokenImplementation: {
    [ChainId.Ethereum]: "0x1583A4Eb50Bdde67F44A506a16c6d90C1E0A46d3",
    [ChainId.Sepolia]: "0x45c382574bb1B9C432a2e100Ab2086A4EAcB73Fd",
    [ChainId.Polygon]: "0x315d005Ea83E2B296CeD559F8228266dDa885091",
    [ChainId.PolygonAmoy]: "0x45c382574bb1B9C432a2e100Ab2086A4EAcB73Fd",
    [ChainId.StabilityTestnet]: "0x6c22FD7C07b0cdcaEA0FfB43B3Aa955D1Ee83491",
    [ChainId.Stability]: "0x9093AD686C92572750d7399484131F0b3E02b62A",
    [ChainId.XDC]: "0xCdF35cA8e01f5693B23135C7a92B8FefeFd0bDd0",
    [ChainId.XDCApothem]: "0xcc72c1b3f7875fda22bcdb147d462d7da64efc55",
    [ChainId.Astron]: "0x025aF5b49f1755C536d6965093C88d85A7Ec3300",
    [ChainId.AstronTestnet]: "0xA0Da221B3cd3e863425E1F1D34B9307D295a9d03"
  }
};